import React from 'react';

const AddUsuarioButton = ({ openAddUsuarioModal }) => {
  return (
    <div className="col-12 col-xl-3 col-md-6 py-1">
      <button 
        type="button" 
        className="d-flex align-items-center justify-content-center btn btn-primary text-white w-100 fw-semibold"
        onClick={openAddUsuarioModal}
      >
        <i className="bi bi-plus fs-4"></i> Usuário
      </button>
    </div>
  );
};

export default AddUsuarioButton; 